import axios from 'axios'
import { alertService } from './alertService'

const URLPrinter = process.env.REACT_APP_API_PRINTER_HOST // For printer local --port 8000
const baseURL = process.env.REACT_APP_URL_PATH_API

// Method to verify if the printer is avaliable
export const IsAvaliablePrint = async (): Promise<boolean> => {
  let result: boolean
  try {
    const response = await axios.get(`${URLPrinter}`)
    if (response.status === 200) {
      result = true
    } else {
      result = false
    }
  } catch (error) {
    alertService.error(
      'No se pudo comunicar con la impresora, verifique que el programa se este ejecutando.'
    )
    result = false
  }
  return result
}

/**
 * Manda a la impresora local un ZPL que YA se obtuvo por otro lado.
 *
 * `PrintLabel` (abajo) acopla dos cosas: traer la etiqueta del `.NET GetShipmentLabelV2`
 * y mandarla al agente. Ese acople obliga al llamador a tener `ServiceID` y
 * `BuCodeSource`, que el detalle de carga masiva no tiene. Esta función hace SOLO la
 * segunda mitad, para poder alimentarla desde `getShipmentZebraLabel` (Django), que
 * resuelve esos dos campos desde la base.
 *
 * Diferencia clave con `PrintLabel`: **devuelve el motivo en vez de alertar**.
 * `IsAvaliablePrint` avisa por `alertService`, cuyo host `<Alert />` no está montado en
 * la app, así que ese aviso es invisible. El llamador tiene que mostrarlo en un modal.
 */
export const sendLabelToPrinter = async (
  stringLabel: string[],
  labelFormat: string
): Promise<{
  ok: boolean
  reason?: 'agent-down' | 'print-failed'
  message?: string
}> => {
  if (!Array.isArray(stringLabel) || stringLabel.length === 0) {
    return {
      ok: false,
      reason: 'print-failed',
      message: 'No hay etiqueta que imprimir.',
    }
  }

  // Sonda al agente local ANTES de mandar: si no está corriendo, el POST de abajo falla
  // igual pero con un error de red genérico que no dice qué hacer.
  try {
    const probe = await axios.get(`${URLPrinter}`)
    if (probe.status !== 200) {
      return {
        ok: false,
        reason: 'agent-down',
        message:
          'No se pudo comunicar con la impresora. Verificá que el programa de impresión esté ejecutándose.',
      }
    }
  } catch (error: any) {
    return {
      ok: false,
      reason: 'agent-down',
      message:
        'No se pudo comunicar con la impresora. Verificá que el programa de impresión esté ejecutándose.',
    }
  }

  try {
    await axios.post(`${URLPrinter}/PrintMultipleShipment`, {
      StringLabel: stringLabel,
      LabelFormat: labelFormat,
    })
    return { ok: true }
  } catch (error: any) {
    return {
      ok: false,
      reason: 'print-failed',
      message:
        error?.response?.data?.message ??
        error?.message ??
        'La impresora rechazó la etiqueta.',
    }
  }
}

//TODO simplify this method
// Method to obtain the labels of the shipment
async function getLabels(
  ShipmentNumber: number,
  ServiceID: number,
  BuCodeSource: string,
  PiecesNumber: number[],
  FormatType: number
) {
  let respose: any = []
  await axios
    .post(`${baseURL}/v1/Shipment/GetShipmentLabelV2`, {
      ShipmentNumber,
      ServiceID,
      BuCodeSource,
      PiecesNumber,
      FormatType,
    })
    .then((res) => {
      respose = res.data
    })
    .catch((error) => {
      console.log(error)
    })
  return respose
}
// Method to print the labels of the shipment using the external printer service
export const PrintLabel = async (
  ShipmentNumber: number,
  ServiceID: number,
  BuCodeSource: string,
  PiecesNumber: number[],
  FormatType: number = 1
): Promise<boolean> => {
  let result: boolean

  let StringLabel = await getLabels(
    ShipmentNumber,
    ServiceID,
    BuCodeSource,
    PiecesNumber,
    FormatType
  )

  try {
    if (StringLabel.stringLabel.length === 0) {
      alertService.error(
        'Guía: ' + ShipmentNumber,
        'No se pudo obtener ninguna etiqueta de la guía especificada.'
      )
      return false
    }
    let AvaliablePrint = await IsAvaliablePrint()
    if (!AvaliablePrint) {
      return false
    }
    result = await new Promise(async (resolve, rejected) => {
      await axios
        .post(`${URLPrinter}/PrintMultipleShipment`, {
          StringLabel: StringLabel.stringLabel,
          LabelFormat: StringLabel.labelFormat,
        })
        .then((res) => {
          resolve(true)
        })
        .catch((error) => {
          rejected(false)
        })
    })
  } catch (error) {
    result = false
  }
  return result
}
